import { UserManager, Log } from 'oidc-client';
import jwtDecode from 'jwt-decode';
import SessionStorage from 'libs/SessionStorage';
const manager = process.env.BROWSER ? new UserManager(window.App.oidc) : null;
if (__DEV__) {
    Log.logger = console;
// Log.level = Log.DEBUG;
}
async function logoutCallback() {
    await manager.signoutRedirectCallback();
    await manager.removeUser();
    SessionStorage.clear();
}
async function handleUserSignedOut() {
    const mobileDashboardBlsReturnUrl = SessionStorage.getItem('mobileDashboardBlsReturnUrl');
    await logoutCallback();
    if (mobileDashboardBlsReturnUrl) {
        window.location.href = mobileDashboardBlsReturnUrl;
    } else {
        await manager.signinRedirect();
    }
}
if (manager) {
    manager.events.addUserSignedOut(()=>{
        if (__DEV__) return;
        handleUserSignedOut().catch((error)=>{
            console.error('Error handling handleUserSignedOut:', error);
        });
    });
}
// async function init() {
//   const user = await manager.getUser();
//   console.log('User', user);
//   if (user) {
//     console.log('User logged in', user.profile);
//   } else {
//     console.log('User not logged in');
//   }
//   return user;
// }
async function clearStorageEntries() {
    const keys = await manager.settings.userStore.getAllKeys();
    await Promise.all(keys.map((key)=>manager.settings.userStore.remove(key)));
}
async function login(prompt = null) {
    if (prompt === 'change-password' || prompt === 'switch-identity') {
        await clearStorageEntries();
    }
    await manager.signinRedirect({
        prompt
    });
}
async function loginCallback() {
    await manager.signinRedirectCallback();
}
async function loginSilentCallback() {
    await manager.signinSilentCallback();
}
async function logout() {
    const { userStore } = manager.settings;
    const keys = await userStore.getAllKeys();
    if (keys.length) {
        const values = await Promise.all(keys.map((key)=>userStore.get(key)));
        SessionStorage.clear();
        await Promise.all(keys.map((key, idx)=>userStore.set(key, values[idx])));
    }
    await manager.signoutRedirect();
}
async function clearStaleState() {
    await manager.clearStaleState();
}
async function getUser() {
    return manager && manager.getUser();
}
async function getToken() {
    let user = await getUser();
    if (!user) return null;
    if (user.expired) {
        try {
            user = await manager.signinSilent();
        } catch (err) {
            return null;
        }
    }
    return user.access_token;
}
async function getTokenData() {
    const token = await getToken();
    if (!token) return null;
    return jwtDecode(token);
}
async function getCountryCode() {
    const tokenData = await getTokenData();
    if (!tokenData) return null;
    return tokenData.identity_country_code;
}
async function revokeAccessToken() {
    return manager && manager.revokeAccessToken();
}
const exporter = (func)=>process.env.BROWSER ? func : Promise.resolve(true);
export default {
    login: exporter(login),
    loginCallback: exporter(loginCallback),
    loginSilentCallback: exporter(loginSilentCallback),
    logout: exporter(logout),
    clearStaleState: exporter(clearStaleState),
    getUser: exporter(getUser),
    getToken,
    getTokenData: exporter(getTokenData),
    getCountryCode: exporter(getCountryCode),
    revokeAccessToken: exporter(revokeAccessToken),
    logoutCallback: exporter(logoutCallback)
};
